module.exports = __webpack_public_path__ + "onboarding2.png";